module.exports = __webpack_public_path__ + "static/ems-home-services-logo-lg.c7941d95.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ems-home-services-logo-lg.png
// module id = 138
// module chunks = 35783957827783 114276838955818